export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_01.3250cb53.jpg";